import { getterTypes, mutationTypes, actionTypes } from 'BASE/store/types';
import { getCollection, setCollection } from 'BASE/common/collection/collection';

let _id = 0;
function state() {
    return {
        _id: _id++,
        collections: [],
    };
}

const getters = {
    [getterTypes.BET_GET_COLLECTIONS](state) {
        return state.collections;
    },
};

const mutations = {
    [mutationTypes.BET_SET_COLLECTIONS](state, payload) {
        state.collections = payload.data;
    },
};

const actions = {
    async [actionTypes.BET_GET_COLLECTIONS]({ state, commit }, payload) {
        var data = await getCollection(payload.userName, payload.collectionType);
        commit(mutationTypes.BET_SET_COLLECTIONS, { data });
    },
    async [actionTypes.BET_SET_COLLECTIONS]({ state, commit, dispatch }, payload) {
        await setCollection(payload.userName, payload.gameIdArr, payload.collectionType);
        await dispatch(actionTypes.BET_GET_COLLECTIONS, { userName: payload.userName, collectionType: payload.collectionType});
    },
};

export default class store {
    constructor() {
        this.state = state();
        this.getters = getters;
        this.mutations = mutations;
        this.actions = actions;
    }
}